/**
 * const.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { TypeForm }     from '~/components/typeForm';
import { AddressForm }  from '~/components/addressForm';
import { ExtrasForm }   from '~/components/extrasForm';
import { PersonalForm } from '~/components/personalForm';

export const steps = [
  {
    withBack: false,
    title:    'Wo befindet sich Ihre Immobilie?',
    nextLabel: 'Weiter',
    component: (props: any) => <AddressForm {...props} />,
  },
  {
    title:    'Grundlegende Informationen über Ihre Immobilie',
    nextLabel: 'Weiter',
    component: (props: any) => <TypeForm {...props} />,
  },
  {
    title: 'Weitere Informationen über Ihre Immobilie',
    nextLabel: 'Weiter',
    component: (props: any) => <ExtrasForm {...props} />,
  },
  {
    title: 'Persönliche Informationen',
    nextLabel: 'Bewertung anfordern',
    component: (props: any) => <PersonalForm {...props} />,
  },
  {
    withBack: false,
    title: 'Wir melden uns bei Ihnen',
    nextLabel: 'Zurück zur Startseite',
    component: (props: any) => <div />,
  }
];
